/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components imports
import { Table } from 'antd';

// Misc imports
import { v4 as uuidv4 } from 'uuid';
import { useFetchNlpPipelinesQuery } from '../../../store/nlpPipelines/nlpPipelinesApi';

const GeneralResultsTable = ({ runTestSetResults }) => {
  const { t } = useTranslation();
  const { orgId, tenantId } = useParams();
  const { data: nlpPipelines } = useFetchNlpPipelinesQuery({ orgId, tenantId });

  const columns = [
    {
      title: t('Name'),
      dataIndex: 'nlpPipelineId',
      key: `nlpPipelineId-${uuidv4()}`,
      render: (_text, record) => {
        return nlpPipelines?.items?.find(model => model?.id === record.nlpPipelineId)?.name;
      }
    },
    {
      title: t('Macro Avg. Precision'),
      key: `avgPrecision-${uuidv4()}`,
      dataIndex: 'macroAvgPrecision',
      align: 'center'
    },
    {
      title: t('Macro Avg. Recall'),
      key: `avgRecall-${uuidv4()}`,
      dataIndex: 'macroAvgRecall',
      align: 'center'
    },
    {
      title: t('Macro Avg. F-1 Score'),
      key: `avgF1Score-${uuidv4()}`,
      dataIndex: 'macroAvgF1Score',
      align: 'center'
    },
    {
      title: t('Accuracy'),
      key: `accuracy-${uuidv4()}`,
      dataIndex: 'accuracy',
      align: 'center'
    }
  ];

  return (
    <Table
      size="small"
      dataSource={runTestSetResults}
      rowKey={uuidv4()}
      columns={columns}
      pagination={{
        size: 'default',
        showTotal: (total) => `${t('Total Results')}: ${total}`
      }}
    />
  );
};

GeneralResultsTable.propTypes = {
  runTestSetResults: PropTypes.array
};

export default GeneralResultsTable;
